<template>
    <div v-loading="loading">
        <div class="header-btn">
            <el-button type="warning" size="small" @click="openCreate" icon="el-icon-plus"></el-button>
        </div>

        <el-table
                class="data-table"
                stripe
                :data="tableData"
                style="width: 100%">
            <el-table-column
                    v-for="item in  [
                 {label:'Facility Type',prop:'type.name'},
                 {label:'Name',prop:'name'},
                 {label:'Updated',prop:'updated',fmt:selfTimeFormat}]"
                    :prop="item.prop"
                    :width="item.width"
                    :label="item.label"
                    :formatter="item.fmt"
                    :key="item.prop">
            </el-table-column>

            <el-table-column
                    label="Action"
                    header-align="center"
                    align="center"
                    width="230px">
                <template slot-scope="s">
                    <el-tooltip content="Edit" placement="top">
                        <el-button type="text" @click="openEdit(s.row)" size="mini" icon="el-icon-edit"
                                   style="background-color: #0198E1;color: white;padding: 7px 15px"></el-button>
                    </el-tooltip>

                    <el-tooltip content="Copy" placement="top">
                        <el-button type="text" @click="copyOne(s.row)" size="mini" icon="el-icon-document-copy"
                                   style="background-color: #FF7D40;color: white;padding: 7px 15px"></el-button>
                    </el-tooltip>

                    <el-tooltip content="Delete" placement="top">
                        <el-button type="text" @click="deleteData(s.row.id)" size="mini" icon="el-icon-delete"
                                   style="background-color: #FF3030;color: white;padding: 7px 15px"></el-button>
                    </el-tooltip>

                    <el-tooltip content="Block" placement="top">
                        <el-button type="text" size="mini" icon="el-icon-date" @click="openBlockedPanel(s.row.id)"
                                   style="background-color: #43CD80;color: white;padding: 7px 15px"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
                v-if="showEditDialog"
                center
                :close-on-click-modal="false"
                :visible.sync="showEditDialog"
                width="50%">
            <el-form ref="form" :model="form" label-width="200px" label-position="left">
                <el-form-item required label="Facility Type" prop="typeId">
                    <el-select v-model="form.typeId" placeholder="Select a type">
                        <el-option
                                v-for="item in facilityTypes"
                                :key="'f-t'+item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item required label="Name" prop="name">
                    <el-input v-model="form.name" class="type-name" style="width: 220px"></el-input>
                </el-form-item>

                <el-form-item required label="Image">
                    <icon-uploader v-if="form.pic" :url.sync="form.pic.path" :fid.sync="form.image"></icon-uploader>
                </el-form-item>

                <el-form-item label="Payment Require?">
                    <el-switch v-model="form.paymentRequire" active-color="#13ce66" :inactive-value="false"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="Refundable deposit" v-if="form.paymentRequire" prop="refundable"
                              :required="form.paymentRequire">
                    <el-input-number v-model="form.refundable" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Fee" v-if="form.paymentRequire" prop="deposit" :required="form.paymentRequire">
                    <el-input-number v-model="form.deposit" :min="0"></el-input-number>
                </el-form-item>

                <el-form-item label="Booking Slot Days">
                    <el-checkbox v-for="(day,index) in daysList"
                                 :label="day.label" :checked="day.checked" :key="day.label"
                                 @change="changeDayStat(day.label,index)"></el-checkbox>
                </el-form-item>
            </el-form>

            <div v-for="(item,dayIndex) in openingDay" :key="'day-index'+dayIndex">
                <el-row>
                    <el-col :span="3" v-if="dayIndex ===0">
                        <el-button type="primary" size="mini" @click="applyToAllDate">Apply to All Date</el-button>
                    </el-col>

                    <el-col :offset="dayIndex !==0 ?10: 7" :span="2">
                        <span class="sessions-title">{{item.day}}</span>
                    </el-col>

                    <el-col :offset="5" :span="3">
                        <el-button class="sessions-btn" type="warning" icon="el-icon-plus" size="mini"
                                   @click="addSession(item)">Add new session</el-button>
                    </el-col>
                </el-row>

                <el-container v-for="(sItem,sIndex) in item.sessions" :key="'day-index='+dayIndex+'session+'+sIndex">
                    <el-container>
                        <el-main>
                            <el-row>
                                <el-col :span="5">
                                    <el-tooltip class="item" effect="dark" :disabled="sIndex===0"
                                                content="Click to delete this"
                                                placement="top">
                                        <div class="session" @click="deleteSession(item,sIndex)">Session {{sIndex+1}}
                                        </div>
                                    </el-tooltip>
                                </el-col>
                                <el-col :span="8">
                                    <el-time-select
                                            v-model="sItem.start"
                                            :picker-options="pickerOptions"
                                            placeholder="Check session start time">
                                    </el-time-select>
                                </el-col>
                                <el-col :span="2"><span class="session">to</span></el-col>
                                <el-col :span="8">
                                    <el-time-select
                                            v-model="sItem.end"
                                            :picker-options="pickerOptions"
                                            placeholder="Check session end time">
                                    </el-time-select>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="5"><span class="session">Session duration</span></el-col>
                                <el-col :span="7">
                                    <el-time-select
                                            v-model="sItem.duration"
                                            :picker-options="durPickerOptions"
                                            placeholder="Check session duration">
                                    </el-time-select>
                                </el-col>
                                <el-col :span="2">
                                    <el-checkbox v-model="sItem.peak">Peak Session</el-checkbox>
                                </el-col>
                            </el-row>
                        </el-main>
                    </el-container>
                </el-container>
                <hr style="margin-bottom: 15px">
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">Save</el-button>
      </span>
        </el-dialog>
        <facility-blocked :fid="fid" :blocked-dialog-visible.sync="blockedDialogVisible"
                          v-if="blockedDialogVisible"></facility-blocked>
    </div>
</template>

<script>
    import {facility, facilityCreate, facilityDelete, facilityTypes, facilityUpdate} from '@/api/Facitliy'
    import IconUploader from '../../../components/IconUploader'
    import FacilityBlocked from "@/view/property/facility/FacilityBlocked";
    // noinspection JSUnusedGlobalSymbols
    export default {
        name: 'Facility',
        components: {FacilityBlocked, IconUploader},
        data() {
            return {
                tableData: [],
                loading: false,
                form: {},
                openingDay: [],
                blockedDialogVisible: false,
                fid: null,
                facilityTypes: [],
                showEditDialog: false,
                daysList: [],
                pickerOptions: {
                    start: '00:00',
                    step: '00:15',
                    end: '23:59'
                },
                durPickerOptions: {
                    start: '00:30',
                    step: '00:30',
                    end: '23:59'
                }
            }
        },
        methods: {
            loadData() {
                facility()
                    .then(res => {
                        this.tableData = res.data
                    })
            },
            addSession(day) {
                const session = {peak: false}
                day.sessions.push(session)
            },
            maxSlotFmt(row) {
                let day = Math.max(row.maxSlotDayPeak, row.maxSlotDay)
                let week = Math.max(row.maxSlotWeekPeak, row.maxSlotWeek)
                let month = Math.max(row.maxSlotMonthPeak, row.maxSlotMonth)
                return `${day} /${week} /${month}`
            },
            openCreate() {
                this.loadTypes()
                this.form = {
                    pic: {}
                }
                this.openingDay = []
                this.initDays()
                this.showEditDialog = true
            },
            copyOne(data) {
                const newDoc = this.$copy(data);
                newDoc.id = null;
                this.openEdit(newDoc)
            },
            deleteSession(day, sessionIndex) {
                if (sessionIndex === 0) {
                    return
                }
                day.sessions.splice(sessionIndex, 1)
            },
            initDays() {
                this.daysList = [{label: 'Mon'}, {label: 'Tue'}, {label: 'Wed'}, {label: 'Thu'}, {label: 'Fri'}, {label: 'Sat'}
                    , {label: 'Sun'}, {label: 'Ph'}]
            },
            openEdit(data) {
                this.loadTypes()
                this.form = JSON.parse(JSON.stringify(data))
                this.openingDay = JSON.parse(this.form.openingDay)
                this.initDays()
                this.convertDuration(this.convertToTime)
                this.processCheckedDays()
                this.showEditDialog = true

            },
            changeDayStat(label, index) {
                const val = this.daysList[index]
                //手动设置值
                val.checked = !val.checked
                if (val.checked) {
                    this.openingDay.splice(index, 0, {day: label, sessions: [{}]})
                } else {
                    this.openingDay = this.openingDay.filter(item => item.day !== label)
                }
            },
            save() {
                const action = this.form.id ? facilityUpdate : facilityCreate
                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        this.convertDuration(this.convertToNum)
                        delete this.form.pic
                        this.form.openingDay = JSON.stringify(this.openingDay)
                        action(this.form)
                            .then(() => {
                                this.loadData()
                                this.showEditDialog = false
                            })
                    }
                })

            }, applyToAllDate() {
                if (this.openingDay && this.openingDay[0].sessions) {
                    const dayOpenSessions = this.openingDay[0].sessions
                    this.openingDay.forEach(item => item.sessions = this.$copy(dayOpenSessions))

                }
            },
            convertDuration(action) {
                this.openingDay.forEach(day => {
                    day.sessions.forEach(session => {
                        session.duration = action(session.duration)
                    })
                })
            },
            openBlockedPanel(id) {
                this.fid = id
                this.blockedDialogVisible = true
            },
            convertToTime(num) {
                let h = Math.floor((num / 60))
                let m = (num % 60)
                h = h > 10 ? h : '0' + h
                m = m > 10 ? m : '0' + m
                return h + ':' + m
            },
            convertToNum(time) {
                time = time.split(':')
                let h = parseInt(time[0])
                let m = parseInt(time[1])
                return h * 60 + m
            },
            deleteData(id) {
                this.$deleteRequest(this, facilityDelete, id)
            },
            loadTypes() {
                facilityTypes()
                    .then(res => {
                        this.facilityTypes = res.data
                    })
            },
            processCheckedDays() {
                let selectedDay = this.openingDay.map(x => x.day)
                this.daysList.forEach(x => {
                    x.checked = selectedDay.includes(x.label)
                })

            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>
    .slots-conf div {
        display: inline-table !important;
        width: 230px;
    }

    .type-name {
        width: unset;
    }

    .check-box {
        margin-left: 6px;
    }

    .sessions-title {
        font-size: 29px;
        line-height: 29px;
        padding-bottom: 20px;
        margin-top: 10px;
    }

    .session {
        font-size: 16px;
    }

    .el-button {
        margin-right: 5px;
    }
</style>
